import styled from "styled-components";
import { FlexColumn, FlexRow, Modal, ModalContainer, P } from "notes";
import { ModalLink } from "Components";
import { useBrandingContext } from "Context";
import { ReactNode } from "react";

interface DrawerProps {
  open: boolean;
  onClose: (val: void) => void;
  children: any;
  title?: string;
  hideAction?: boolean;
  showSearch?: boolean;
  searchResults?: any;
  header?: ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({
  open = false,
  onClose,
  children,
  title = "",
  hideAction = false,
  header,
  ...props
}) => {
  const { logoAlt, logos } = useBrandingContext();
  const darkLogo = logoAlt ? logoAlt : logos?.dark?.path;
  return (
    <Wrapper size="small" open={open} setOpen={() => {}} {...props}>
      <Chrome yCenter>
        <ChromeContent yCenter>
          {header ? (
            header
          ) : (
            <>
              {title ? <P>{title}</P> : <LogoImage src={darkLogo} alt="" />}
              {!hideAction && (
                <ModalLink onClick={() => onClose()}>Cancel</ModalLink>
              )}
            </>
          )}
        </ChromeContent>
      </Chrome>
      <DrawerContent>{children}</DrawerContent>
    </Wrapper>
  );
};

const Wrapper = styled(Modal)`
  align-items: flex-end;
  justify-content: center;
  flex-direction: row;
  ${ModalContainer} {
    align-items: center;
    overflow-y: scroll;
    align-self: initial;
    padding: 0;
    margin-top: 0;
    max-height: 100%;
    min-height: initial;
    max-width: 600px;
    transition: height 0.2s cubic-bezier(0, 0, 0.3, 1);
    & > svg {
      display: none;
    }
    @media only screen and ${(props) => props.theme.media.medium} {
      border-radius: 6px 6px 0 0;
    }
  }
`;

export const DrawerContent = styled(FlexColumn)`
  width: 100%;
  max-width: 600px;
  flex-grow: 1;
`;

const ChromeContent = styled(FlexColumn)`
  width: 100%;
  max-width: 600px;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;

const Chrome = styled(FlexRow)`
  background: #ffffff;
  border-bottom: 2px solid ${(props) => props.theme.palette.gray.lightest};
  flex: 0 0 48px;
  justify-content: center;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 500;
  ${P} {
    font-weight: 700;
  }
`;

const LogoImage = styled.img`
  width: ${(props) => props.theme.branding.logos?.dark?.width};
  object-fit: contain;
`;
